module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAcElEQVR4AWOgC7gtKnVHRvGeuvY9ZY3b4jL/cQOohltC4o/snd/39L0uLL6roEqEBkGxFynpX9ete5GSdldFg7CG2yKSD20c7mnpPzS3Jk6DmDTQG0CH3RaWAPoByMWFEBqQEe01MDQw4EKDUMPgBAB/stlRR7MNCgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/OM.png
// module id = 1235
// module chunks = 0